(() => {
  const enhanceSizeChartDialog = () => {
    const modal = document.querySelector('.tingle-modal.size_chart.tingle-modal--visible');
    if (!modal) return;

    const title = modal.querySelector('.title-popup');
    const closeButton = modal.querySelector('.tingle-modal__close');
    const titleText = title?.textContent?.trim() || 'Size Guide';

    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    if (title) {
      title.id = title.id || 'BroekSizeChartTitle';
      modal.setAttribute('aria-labelledby', title.id);
    }

    if (closeButton) {
      closeButton.setAttribute('aria-label', `Close ${titleText}`);
    }

    modal.querySelectorAll('img').forEach((image) => {
      if (!image.getAttribute('alt')?.trim()) {
        image.setAttribute('alt', 'BROEK size chart with garment measurements');
      }
    });
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest('product-addons button[aria-haspopup="dialog"]')) return;
    requestAnimationFrame(enhanceSizeChartDialog);
  });
})();
